(function () {
  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

  function calcCount(seed) {
    // 2..7 reseñas según seed (determinístico)
    const n = (Number(seed) || 0) % 5;  // 0..4
    return 2 + n;                       // 2..6
  }

  function applyFakeRatings(root = document) {
    root.querySelectorAll('.js-fake-rating').forEach((el) => {
      const seed = el.dataset.seed;
      const count = calcCount(seed);

      const countNode = el.querySelector('.js-rating-count');
      if (countNode) countNode.textContent = String(count);

      // Actualiza aria-label también
      const rating = el.dataset.rating || '5.00';
      el.setAttribute('aria-label', `${rating} de 5 estrellas, ${count} reseñas`);
    });
  }

  document.addEventListener('DOMContentLoaded', () => applyFakeRatings());

  // Para el Theme Editor: cuando Shopify re-renderiza secciones.
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => applyFakeRatings(e.target));
  }
})();
